import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Button, Span } from './button-style'
import { ReactComponent as IconLeft } from '@assets/images/icon-arrow-left.svg'
import { ReactComponent as IconRight } from '@assets/images/icon-arrow-right.svg'
import { ReactComponent as IconLoading } from '@assets/images/button-loading.svg'
import classNames from 'classnames'

const ButtonComponent = ({ id, disabled, className, onClick, children, isLoading, theme, icon, type }) => {
  const [isLoadingState, setIsLoadingState] = useState(isLoading || false)
  const isIconLeft = icon === 'left'
  const isIconRight = icon === 'right'

  const handlerOnClick = async () => {
    setIsLoadingState(true)
    if (onClick) await Promise.resolve(onClick())
    setIsLoadingState(false)
  }

  useEffect(() => {
    setIsLoadingState(isLoading)
  }, [isLoading])

  return (
    <Button
      role="button"
      type={type || 'button'}
      theme={theme}
      disabled={disabled}
      id={id}
      className={classNames({ loading: isLoading }, className)}
      isLoading={isLoadingState}
      onClick={handlerOnClick}
      icon={icon}
    >
      {isIconLeft && <IconLeft />}

      {!isLoadingState && <Span icon={icon}>{children}</Span>}
      {isLoadingState && <IconLoading />}

      {isIconRight && <IconRight />}
    </Button>
  )
}

ButtonComponent.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.string,
  theme: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string,
}

export default ButtonComponent
